import { Action, createReducer, on } from '@ngrx/store';

import { fetchSeamlessLoginTokenSuccessAction } from '@app/store/actions/global.actions';

export const initialState: string = null;

const featureReducer = createReducer(
  initialState,
  on(fetchSeamlessLoginTokenSuccessAction, (state, { response }) => {
    return response;
  }),
);

export const seamlessLoginReducer = (state: string, action: Action): string => {
  return featureReducer(state, action);
};
